import { Dialog, DialogTitle, DialogActions, Button } from "@mui/material";
import { NewTask } from "./new-tasks/types";
import { Dispatch, SetStateAction } from "react";

const RequiredDocAlertModal = ({
  open,
  closeModal,
  task,
  setSelectedTaskUploadDocument
}: {
  open: boolean;
  closeModal: () => void;
  task?: NewTask;
  setSelectedTaskUploadDocument?: Dispatch<SetStateAction<NewTask | null>>;
}) => {
  const upload = () => {
    if (setSelectedTaskUploadDocument && task) {
      setSelectedTaskUploadDocument(task);
      closeModal();
    }
  };
  return (
    <Dialog open={open} onClose={closeModal} fullWidth maxWidth="sm">
      <DialogTitle>A document must be uploaded before marking this task as completed.</DialogTitle>
      <DialogActions>
        {task && (
          <Button variant="contained" onClick={upload}>
            Upload Document
          </Button>
        )}
        <Button variant="contained" onClick={closeModal} color="inherit">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequiredDocAlertModal;
